<template>
  <div class="hello">
    <h1><span class="host">rina.sh</span><span class="path">/meleva</span></h1>
    <div>
      <p>
        Hi 👋
      </p>
      <p>
        I’m Rina — 👷‍♀️ full-stack web &#38; mobile app developer and 👩‍🎓 Aalto
        University MSc student in
        <a
          href="https://into.aalto.fi/display/enccis/Security+and+Cloud+Computing+%28Security%29+2018-2020"
          target="_blank"
          rel="noopener"
          >Security and Cloud Computing</a
        >
        and
        <a
          href="https://into.aalto.fi/display/ensivuaineet2018/Human-Computer+Interaction"
          target="_blank"
          rel="noopener"
          >Human-Computer Interaction</a
        >
      </p>
      <p>
        <span class="ls"
          >Feel like talking over a bowl of noodles? Drop me a line!</span
        >
        <br />
        [etunimi].[sukunimi][at]ya.ru
        <br />
        <a href="https://github.com/shmeleva" target="_blank" rel="noopener"
          >GitHub</a
        >
        *
        <a
          href="https://www.linkedin.com/in/eshmeleva/"
          target="_blank"
          rel="noopener"
          >LinkedIn</a
        >
        *
        <a
          href="https://www.instagram.com/rina.shmeleva/"
          target="_blank"
          rel="noopener"
          >Instagram</a
        >
      </p>
    </div>
    <div>
      <h3>Education</h3>
      <p>
        09/2012 – 07/2016
        <br />
        <strong>BSc in Mathematics and Computer Science</strong>
        <br />
        MESI →
        <a
          href="https://www.rea.ru/en/Pages/default.aspx"
          target="_blank"
          rel="noopener"
          >PRUE</a
        >
        (Moscow, Russia)
        <br />
        5.0 / 5.0
      </p>
      <p>
        09/2018 – present
        <br />
        <strong>MSc in Computer, Communication and Information Sciences</strong>
        <br />
        <a href="https://www.aalto.fi/en" target="_blank" rel="noopener"
          >Aalto University</a
        >
        (Espoo, Finland)
        <br />
        4.9 / 5.0
      </p>
    </div>
    <div>
      <h3>Work-work-work!</h3>
      <p>
        02/2016 – 08/2018
        <br />
        <strong>Software Developer</strong>
        <br />
        <a href="https://vestbery.com/" target="_blank" rel="noopener"
          >Vestbery</a
        >
        (Moscow, Russia)
      </p>
      <p>
        06/2019 – 08/2019 ☀️
        <br />
        <strong>Software Developer</strong>
        <br />
        <a href="https://www.reaktor.com/" target="_blank" rel="noopener"
          >Reaktor</a
        >
        (Helsinki, Finland)
      </p>
    </div>
    <div>
      <h3>Skills</h3>
      <p>
        <span class="ls">frontend rinashmeleva$ ls</span>
        <br />
        Vue.js, ReactJS
        <br />
        <span class="ls">mobile rinashmeleva$ ls</span>
        <br />
        React Native, Xamarin, Android
        <br />
        <span class="ls">backend rinashmeleva$ ls</span>
        <br />
        ASP.NET, Node.js
        <br />
        <span class="ls">languages rinashmeleva$ ls</span>
        <br />
        C#, JavaScript, TypeScript, Kotlin
        <br />
        <span class="ls">skills rinashmeleva$ _</span>
      </p>

      <p />
    </div>
    <div>
      <h3>Values</h3>
      <p>
        * Building products beautiful inside &#38; out
        <br />
        * Being part of a team &#38; taking personal responsibility
        <br />
        * Welcoming new &#38; unknown challenges
      </p>

      <p />
    </div>
    <div>
      <h3>Faves</h3>
      <p>
        * Taking tons of photographs &#38; never sharing
        <br />
        * Reading &#38; complaining about urban planning
        <br />
        * Exploring cities &#38; spending time in nature
        <br />
        * Making awkward attempts at snowboarding
        <br />
        * Noodles 🍜
      </p>

      <p />
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@mixin user-select($select) {
  -webkit-touch-callout: #{$select};
  @each $pre in -webkit-, -moz-, -ms-, -o-, -khtml- {
    #{$pre + user-select}: #{$select};
  }
  #{user-select}: #{$select};
}
h1 {
  @include user-select(none);
}
h3 {
  margin: 40px 0 0;
  text-transform: uppercase;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a,
.host {
  color: #e3bbd1;
}
.hello {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 640px;
}
.path {
  color: #879bc6;
}
.ls,
.scheme {
  color: #a1aace;
}
</style>
